import { useContext, useState, useEffect } from 'react'; 
import styles from './UserManagment.module.css';
import ArrowBelow from '../../assets/arrow_below.svg'
import { UserContext } from '../../context/UserContext';
import { getUsersByStoreV2 } from '../../hooks/User';
import { getStoresFromDatabase } from '../../hooks/Store';
import { formatCPF } from '../../utils/FormatUtils';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const UserManagment = () => {
    const { 
        isCreatedUser, 
        clearSuccess, 
        isDeletedUser, 
        isEditedUser,
        setUser, 
    } = useContext(UserContext);

    const [users, setUsers] = useState([]);
    const [stores, setStores] = useState([]);
    const [userTableLineId, setUserTableLineId] = useState(null);
    const [selectedStoreId, setSelectedStoredId] = useState(null);

    useEffect(() => {
        fetchStores();
        fetchUsersByStoreIdV2(selectedStoreId);
        if (isCreatedUser !== null) {
            if (isCreatedUser) {
                toast.success("Usuário criado com sucesso.");
            } else {
                toast.error("Erro ao criar o usuário.");
            }
            clearSuccess();
        }

    }, [isCreatedUser, clearSuccess, selectedStoreId]);

    useEffect(() => {
        if (isEditedUser !== null) {
            if (isEditedUser) {
                toast.success("Usuário editado com sucesso.");
            } else {
                toast.error("Erro ao editar usuário.");
            }
            clearSuccess();
        }
    }, [isEditedUser, clearSuccess]);

    useEffect(() => {
        if (isDeletedUser !== null) {
            if (isDeletedUser) {
                toast.success("Usuário excluído com sucesso.");
            } else {
                toast.error("Erro ao excluir usuário.");
            }
            clearSuccess();
        }
    }, [isDeletedUser, clearSuccess]);

    const handleRowClick = ( user ) => {
        setUserTableLineId(user.id);
        setUser(user)
    };

    const renderStore = ( user ) => {
        if (user?.role === "MANAGER" || user?.role === "MASTER") {
            return <td>Gerencial</td>;
        } 
        return (
            <td>{user?.stores?.[0]?.name || ''}</td>
        );
    };
      
    const handleUserRole = (role) => {
        switch (role) {
            case "MASTER":
                return "Master/Admin";
            case "MANAGER":
                return "Gerente";
            case "APP_USER":
                return "Usuário de App";
            case "PANEL_USER":
                return "Usuário de Painel";
            default:
                return "";
        }
    };

    const handleStoreChange = (event) => {
        const storeId = event.target.value;
        setSelectedStoredId(storeId);

    };

    const fetchUsersByStoreIdV2 = async (storeId) => {
           try {
            const response = await getUsersByStoreV2(storeId);
            if (response?.data?.users) {
                setUsers(response.data.users);
            } else {
                console.error("Failed to fetch users.");
            }
        } catch (error) {
            console.error("Error fetching stores:", error);
        }
    };

     const fetchStores = async () => {
        try {
            const storeData = await getStoresFromDatabase();
            if (storeData) {
                setStores(storeData.data.stores);
            }
        }catch(err) {
            console.error("Error to search stores:", err);
        }
    };

    return (
        <div className={styles.container}>
            <ToastContainer />
            <div className={styles.infoLine}>
                
                <div className={styles.infoLineHead}>
                    <img src={ArrowBelow} alt="Seta para baixo" />
                    <h4 className={styles.headerInfo}>Tabela de Usuários</h4>
                </div>  

                <div className={styles.infoLineSelected}>
                    <select className={styles.storeDropdown} onChange={ handleStoreChange }>
                        <option value="" disabled selected>Selecione uma loja</option>
                        {stores.map((store) => (
                            <option key={store.id} value={store.id}>{store.name}</option>
                        ))}
                    </select>
                </div>
            </div>

            <div className={styles.tableItems}>
                <table>
                    <thead>
                        <tr>
                            <th><div className={styles.scrollableHeader}>Nome</div></th>
                            <th><div className={styles.scrollableHeader}>Login/CPF</div></th>
                            <th><div className={styles.scrollableHeader}>Função</div></th>
                            <th><div className={styles.scrollableHeader}>Senha</div></th>
                            <th><div className={styles.scrollableHeader}>Telefone</div></th>
                            <th><div className={styles.scrollableHeader}>Loja</div></th>
                        </tr>
                    </thead>
                    <tbody>
                        {users.length > 0 ? (
                            users.map((user) => (
                                <tr 
                                    key={user.id}
                                    onClick={() => handleRowClick( user )}
                                    className={user.id === userTableLineId ? styles.selectedRow : ''}>
                                    <td>{user.name}</td>
                                    <td>{formatCPF(user.username) || user.username}</td>
                                    <td>{handleUserRole(user.role)}</td>
                                    <td>**********</td>
                                    <td>{user.phone}</td>
                                    { renderStore(user) }
                                </tr>
                            ))
                        ) : null}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default UserManagment;